module.exports = __webpack_public_path__ + "img/cable-sentosa.d497ab07.svg";